import React, { FC } from 'react';

import { cn } from '@crossnokaye/ux-common';

export interface SquareButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
}

export const SquareButton: FC<SquareButtonProps> = ({ icon, onClick, className, ...props }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-[1.625rem] h-[1.625rem] p-[0.0625rem] bg-popover rounded flex justify-center items-center cursor-pointer hover:bg-tertiary',
        className
      )}
      {...props}
    >
      <div className={'w-[1rem] h-[1rem] flex justify-center items-center text-foreground'}>
        {icon}
      </div>
    </button>
  );
};
